/* Ko Samui — Stone Island style home: hero carousel, product rail, category slideshow, focus-on. */
(function () {
  'use strict';
  if (window.__siHomeLoaded) return; // the script tag is rendered by several sections
  window.__siHomeLoaded = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var registry = new WeakMap();

  /* ---------- Hero carousel ---------- */
  function Hero(root) {
    var slides = root.querySelectorAll('.si-hero__slide');
    var bars = root.querySelectorAll('.si-hero__bar');
    var nexts = root.querySelectorAll('[data-next-num]');
    var duration = parseFloat(root.getAttribute('data-duration')) || 6;
    var i = 0, timer = null, paused = reduced;
    root.style.setProperty('--si-duration', duration + 's');
    if (paused) root.classList.add('is-paused');

    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      bars.forEach(function (b, k) {
        b.classList.remove('is-active');
        b.classList.toggle('is-done', k < i);
        void b.offsetWidth; // restart the progress animation
        if (k === i) b.classList.add('is-active');
      });
      nexts.forEach(function (el) { el.textContent = ('00' + (((i + 1) % slides.length) + 1)).slice(-3); });
      schedule();
    }
    function schedule() {
      clearTimeout(timer);
      if (!paused && slides.length > 1) timer = setTimeout(function () { show(i + 1); }, duration * 1000);
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-si]');
      if (!b) return;
      var a = b.getAttribute('data-si');
      if (a === 'prev') show(i - 1);
      if (a === 'next') show(i + 1);
      if (a === 'pause') {
        paused = !paused;
        root.classList.toggle('is-paused', paused);
        b.querySelector('[data-label]').textContent = paused ? b.getAttribute('data-play') : b.getAttribute('data-pause');
        schedule();
      }
    });
    show(0);
    this.destroy = function () { clearTimeout(timer); };
  }

  /* ---------- Continuous rail (products) ---------- */
  function Rail(root) {
    var vp = root.querySelector('.si-rail__viewport');
    var track = root.querySelector('.si-rail__track');
    var items = Array.prototype.slice.call(track.children);
    if (!items.length) return;
    items.forEach(function (n) { var c = n.cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.querySelectorAll('a').forEach(function (a) { a.tabIndex = -1; }); track.appendChild(c); });
    var speed = parseFloat(root.getAttribute('data-speed')) || 30; // px per second
    var x = 0, target = null, paused = reduced, hover = false, last = performance.now(), raf;
    if (paused) root.classList.add('is-paused');

    function half() { return track.scrollWidth / 2; }
    function step() { var it = items[0]; return it.getBoundingClientRect().width + 11; }
    function tick(now) {
      var dt = Math.min(64, now - last) / 1000; last = now;
      if (target !== null) {
        x += (target - x) * Math.min(1, dt * 8);
        if (Math.abs(target - x) < 0.5) { x = target; target = null; }
      } else if (!paused && !hover) {
        x -= speed * dt;
      }
      var h = half();
      if (x <= -h) { x += h; if (target !== null) target += h; }
      if (x > 0) { x -= h; if (target !== null) target -= h; }
      track.style.transform = 'translate3d(' + x + 'px,0,0)';
      raf = requestAnimationFrame(tick);
    }
    vp.addEventListener('mouseenter', function () { hover = true; });
    vp.addEventListener('mouseleave', function () { hover = false; });
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-si]');
      if (!b) return;
      var a = b.getAttribute('data-si');
      if (a === 'prev') target = (target === null ? x : target) + step();
      if (a === 'next') target = (target === null ? x : target) - step();
      if (a === 'pause') togglePause(root, b, (paused = !paused));
    });
    raf = requestAnimationFrame(tick);

    // macOS Dock style magnification on hover (mouse devices only).
    // Turned off on request (Oct 2026): set back to the matchMedia check to re-enable the magnification.
    var canHover = false; // window.matchMedia('(hover: hover) and (pointer: fine)').matches && !reduced;
    var MAX = 1.28, RADIUS = 330;
    function dock(mx) {
      var kids = Array.prototype.slice.call(track.children);
      var vr = vp.getBoundingClientRect();
      var extra = [], scales = [], pivot = -1, best = 1e9;
      kids.forEach(function (k, i) {
        var r = k.getBoundingClientRect();
        var w = r.width / (k.__siScale || 1);
        var cx = r.left + r.width / 2 - (k.__siShift || 0);
        var d = Math.abs(mx - cx);
        var sc = (r.right < vr.left - 300 || r.left > vr.right + 300) ? 1 : 1 + (MAX - 1) * Math.max(0, Math.cos(Math.min(d / RADIUS, 1) * Math.PI / 2));
        scales[i] = sc; extra[i] = (sc - 1) * w;
        if (d < best) { best = d; pivot = i; }
      });
      var acc = 0, before = [];
      extra.forEach(function (e, i) { before[i] = acc; acc += e; });
      var C = before[pivot] + extra[pivot] / 2;
      kids.forEach(function (k, i) {
        var shift = before[i] + extra[i] / 2 - C;
        k.__siScale = scales[i]; k.__siShift = shift;
        k.style.transform = scales[i] === 1 && Math.abs(shift) < 0.5 ? '' : 'translateX(' + shift.toFixed(1) + 'px) scale(' + scales[i].toFixed(3) + ')';
        k.style.zIndex = scales[i] > 1.01 ? String(Math.round(scales[i] * 100)) : '';
      });
    }
    function undock() {
      Array.prototype.forEach.call(track.children, function (k) { k.style.transform = ''; k.style.zIndex = ''; k.__siScale = 1; k.__siShift = 0; });
    }
    if (canHover) {
      root.classList.add('si-rail--dock');
      var mxLast = null, dockRaf = 0;
      vp.addEventListener('mousemove', function (e) {
        mxLast = e.clientX;
        if (!dockRaf) dockRaf = requestAnimationFrame(function () { dockRaf = 0; if (mxLast !== null) dock(mxLast); });
      });
      vp.addEventListener('mouseleave', function () { mxLast = null; undock(); });
    }

    this.destroy = function () { cancelAnimationFrame(raf); };
  }

  /* ---------- Stepping slideshow (categories) ---------- */
  function Slides(root) {
    var track = root.querySelector('.si-cats__track');
    var items = Array.prototype.slice.call(track.children);
    if (items.length < 2) return;
    items.forEach(function (n) { var c = n.cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.tabIndex = -1; track.appendChild(c); });
    var n = items.length, i = 0, paused = reduced, timer = null;
    var delay = (parseFloat(root.getAttribute('data-duration')) || 4) * 1000;
    if (paused) root.classList.add('is-paused');

    function w() { return items[0].getBoundingClientRect().width; }
    function go(k, animate) {
      i = k;
      track.style.transition = animate === false ? 'none' : 'transform 1.1s cubic-bezier(.65,0,.35,1)';
      track.style.transform = 'translate3d(' + Math.round(-i * w()) + 'px,0,0)';
      schedule();
    }
    track.addEventListener('transitionend', function () {
      if (i >= n) go(i - n, false);
      if (i < 0) go(i + n, false);
    });
    function schedule() {
      clearTimeout(timer);
      if (!paused) timer = setTimeout(function () { go(i + 1); }, delay);
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-si]');
      if (!b) return;
      var a = b.getAttribute('data-si');
      if (a === 'next') go(i + 1);
      if (a === 'prev') {
        if (i === 0) { go(n, false); void track.offsetWidth; }
        go(i - 1);
      }
      if (a === 'pause') { togglePause(root, b, (paused = !paused)); schedule(); }
    });
    // Touch swipe: the track follows the finger, release steps to the next/previous image.
    var sx = 0, sy = 0, dx = 0, dragging = false, horiz = null, moved = false;
    track.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      if (i >= n) go(i - n, false);
      sx = e.touches[0].clientX; sy = e.touches[0].clientY; dx = 0; dragging = true; horiz = null; moved = false;
      clearTimeout(timer);
      track.style.transition = 'none';
    }, { passive: true });
    track.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      var mx = e.touches[0].clientX - sx, my = e.touches[0].clientY - sy;
      if (horiz === null && (Math.abs(mx) > 6 || Math.abs(my) > 6)) horiz = Math.abs(mx) > Math.abs(my);
      if (!horiz) return;
      e.preventDefault();
      dx = mx; moved = true;
      if (i === 0 && dx > 0) i = n;
      track.style.transform = 'translate3d(' + Math.round(-i * w() + dx) + 'px,0,0)';
    }, { passive: false });
    track.addEventListener('touchend', function () {
      if (!dragging) return;
      dragging = false;
      if (!moved) { schedule(); return; }
      var lim = w() * 0.15;
      if (dx < -lim) go(i + 1);
      else if (dx > lim) go(i - 1);
      else go(i);
    });
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); moved = false; } }, true);
    var onResize = function () { go(i, false); };
    window.addEventListener('resize', onResize);
    schedule();
    this.destroy = function () { clearTimeout(timer); window.removeEventListener('resize', onResize); };
  }

  /* ---------- Focus on: hover/focus swaps background ---------- */
  function Focus(root) {
    var imgs = root.querySelectorAll('.si-focus__media img');
    var items = root.querySelectorAll('.si-focus__item');
    function set(k) {
      items.forEach(function (it, j) { it.classList.toggle('is-active', j === k); });
      var idx = items[k] && items[k].getAttribute('data-img');
      if (idx === null || idx === undefined) return;
      imgs.forEach(function (im) { im.classList.toggle('is-active', im.getAttribute('data-img') === idx); });
    }
    var active = 0;
    items.forEach(function (it, k) {
      it.addEventListener('mouseenter', function () { active = k; set(k); });
      it.addEventListener('focusin', function () { active = k; set(k); });
    });
    // Mobile carousel: lines follow the swipe, tapping a line scrolls to that story.
    var track = root.querySelector('[data-si-focus-track]');
    var dots = root.querySelectorAll('.si-focus__dot');
    if (track && dots.length) {
      var cards = track.children;
      var current = function () {
        var best = 0, min = Infinity, left = track.getBoundingClientRect().left;
        for (var k = 0; k < cards.length; k++) {
          var d = Math.abs(cards[k].getBoundingClientRect().left - left - parseFloat(getComputedStyle(track).paddingLeft));
          if (d < min) { min = d; best = k; }
        }
        return best;
      };
      var mark = function () { var c = current(); dots.forEach(function (d, k) { d.classList.toggle('is-active', k === c); d.setAttribute('aria-selected', k === c ? 'true' : 'false'); }); };
      var t = 0;
      track.addEventListener('scroll', function () { cancelAnimationFrame(t); t = requestAnimationFrame(mark); }, { passive: true });
      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          var card = cards[parseInt(d.getAttribute('data-i'), 10)];
          if (card) track.scrollTo({ left: card.offsetLeft - parseFloat(getComputedStyle(track).paddingLeft), behavior: 'smooth' });
        });
      });
    }
    // Clicking the background photo opens the story currently shown.
    var media = root.querySelector('.si-focus__media');
    if (media) media.addEventListener('click', function () {
      var url = items[active] && items[active].getAttribute('data-link');
      if (url) window.location.href = url;
    });
    set(0);
  }

  function togglePause(root, btn, paused) {
    root.classList.toggle('is-paused', paused);
    var l = btn.querySelector('[data-label]');
    if (l) l.textContent = paused ? btn.getAttribute('data-play') : btn.getAttribute('data-pause');
  }

  var TYPES = { hero: Hero, rail: Rail, slides: Slides, focus: Focus };

  function init(scope) {
    (scope || document).querySelectorAll('[data-si-type]').forEach(function (el) {
      if (registry.has(el)) return;
      var C = TYPES[el.getAttribute('data-si-type')];
      if (C) registry.set(el, new C(el));
    });
  }
  function destroy(scope) {
    scope.querySelectorAll('[data-si-type]').forEach(function (el) {
      var inst = registry.get(el);
      if (inst && inst.destroy) inst.destroy();
      registry.delete(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { destroy(e.target); });
})();

/* Ko Samui — wishlist "+" on home rail products, powered by the Wishlist Plus (Swym) API.
   Buttons stay hidden until the app is loaded (it only runs after cookie consent). */
(function () {
  'use strict';
  if (window.__siWlLoaded) return;
  window.__siWlLoaded = true;
  var sw = null, lid = null, saved = {};

  function ready(cb) {
    if (window._swat && window._swat.api) return cb(window._swat);
    (window.SwymCallbacks = window.SwymCallbacks || []).push(cb);
  }
  function buttons() { return document.querySelectorAll('.si-wl'); }
  function paint() {
    buttons().forEach(function (b) {
      b.hidden = false;
      var on = !!saved[b.getAttribute('data-empi')];
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
    });
  }
  function load(done) {
    sw.api.fetchLists({
      callbackFn: function (lists) {
        var list = (lists || [])[0];
        function use(l) {
          lid = l.lid; saved = {};
          (l.listcontents || []).forEach(function (it) { saved[String(it.empi)] = true; });
          paint(); if (done) done();
        }
        if (list) use(list);
        else sw.api.createList({ lname: 'My Wishlist' }, function (l) { use(l); }, function () {});
      },
      errorFn: function () {}
    });
  }
  ready(function (s) {
    sw = s;
    load();
    // Rail items are cloned for the infinite scroll: keep new buttons in sync.
    new MutationObserver(function () { if (lid) paint(); }).observe(document.body, { childList: true, subtree: true });
  });

  document.addEventListener('click', function (e) {
    var b = e.target.closest('.si-wl');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    if (!sw || !lid) return;
    var empi = b.getAttribute('data-empi');
    var prod = { epi: Number(b.getAttribute('data-epi')), empi: Number(empi), du: b.getAttribute('data-du') };
    var same = document.querySelectorAll('.si-wl[data-empi="' + empi + '"]');
    same.forEach(function (x) { x.classList.add('is-busy'); });
    var finish = function () { same.forEach(function (x) { x.classList.remove('is-busy'); }); load(); };
    if (saved[empi]) sw.api.deleteFromList(lid, prod, finish, finish);
    else sw.api.addToList(lid, prod, finish, finish);
  }, true);
})();
